// extracted by mini-css-extract-plugin
module.exports = {"nestedWrapper":"styles_nestedWrapper__HLPd6"};